import { Weekday } from '@core-http';

export const weekdayTranslation: Record<Weekday, string> = {
  [Weekday.MONDAY]: 'Poniedziałek',
  [Weekday.TUESDAY]: 'Wtorek',
  [Weekday.WEDNESDAY]: 'Środa',
  [Weekday.THURSDAY]: 'Czwartek',
  [Weekday.FRIDAY]: 'Piątek',
  [Weekday.SATURDAY]: 'Sobota',
  [Weekday.SUNDAY]: 'Niedziela'
};
